import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import type { ManageServiceProviderEventDialogEvent } from './event-dialog-types';

interface DeleteEventDialogProps {
  event: ManageServiceProviderEventDialogEvent;
  onClose: () => void;
  onBack: () => void;
  onSubmit: (eventId: string) => Promise<void>;
}

export function DeleteEventDialog(props: DeleteEventDialogProps) {
  const { event, onClose, onBack, onSubmit } = props;
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  function handleClose() {
    if (isSubmitting) {
      return;
    }

    onClose();
  }

  async function handleDelete() {
    setIsSubmitting(true);
    setError(null);
    try {
      await onSubmit(event.eventId);
      onClose();
    } catch {
      setError('Kunne ikke slette begivenheden. Prøv igen.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Begivenhed</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {error}
          </Alert>
        )}
        <Alert severity="warning" sx={{ mt: 2 }}>
          Er du sikker på at du vil slette begivenheden?
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onBack} disabled={isSubmitting}>
          Tilbage
        </Button>
        <Button
          variant="outlined"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Luk
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={isSubmitting}
        >
          Slet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
